import React from 'react';
import BottomNav from './BottomNav';
import './Auth.css';

const SearchHistory = () => {
  return (
    <div className="auth-container" style={{paddingBottom: 80}}>
      <div style={{height: 24}}></div>
      <div className="search-bar-container" style={{marginTop: 8, marginBottom: 18}}>
        <span className="search-bar-icon">
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="7" />
            <line x1="16.5" y1="16.5" x2="21" y2="21" />
          </svg>
        </span>
        <input className="search-bar-input" type="text" placeholder="Search your history..." />
      </div>
      <div className="mui-card" style={{padding: '18px 12px', marginBottom: 18}}>
        <div className="home-section-title" style={{fontSize: 17, margin: 0, marginBottom: 10}}>Your search history</div>
        <div style={{margin: '0 0 10px 0'}}>
          <span className="search-chip">Field</span>
          <span className="search-chip">Kannur</span>
          <span className="search-chip">House</span>
          <span className="search-chip">Barnav</span>
          <span className="search-chip">Cleaning</span>
        </div>
      </div>
      <div className="mui-card" style={{padding: '18px 12px', marginBottom: 18}}>
        <div className="home-section-title" style={{fontSize: 17, margin: 0, marginBottom: 10}}>Popular Searches</div>
        <div style={{margin: '0 0 10px 0'}}>
          <span className="search-chip">Field Work</span>
          <span className="search-chip">House Cleaning</span>
          <span className="search-chip">Kochi</span>
          <span className="search-chip">Alappuzha</span>
          <span className="search-chip">Land</span>
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default SearchHistory; 